import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import { ICrateMap } from '../../../models/Crate';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { appendParams } from 'src/app/helpers/append-query-params';
import { Level } from 'src/app/modals/stock-levels-model/stock-levels-modal.component';

export interface MapGroundPositionResponse {
  id: string;
  x: number;
  y: number;
  type: string;
  state: string;
  rfId: string;
  alias: string;
  line: number;
  column: string;
  hasPallet: boolean;
  groupId: string | null;
  groupName: string | null;
  levels: Level[];
}

@Injectable({
  providedIn: 'root'
})
export class LayoutService {

  cratesCount$: BehaviorSubject<number> = new BehaviorSubject<number>(0);

  constructor(private httpClient: HttpClient) { }

  async getMap(): Promise<any> {
    const headers = {
      'Content-Type': 'application/json'
    };
    return this.httpClient.get(environment.v3BaseUrl + '/api/v3/admin-desktop/map', { headers }).toPromise<any>();
  }

  getFilteredMap(filter: string, strict = false): Promise<MapGroundPositionResponse[]> {
    const queryParams = { search: filter, strict: strict };
    const params = appendParams(queryParams);
    return this.httpClient.get<MapGroundPositionResponse[]>(environment.v3BaseUrl + '/api/v3/admin-desktop/map', { params }).toPromise();
  }

  async getMapCrates(): Promise<ICrateMap[]> {
    const headers = {
      'Content-Type': 'application/json'
    };
    return this.httpClient.get<ICrateMap[]>(environment.v3BaseUrl + '/api/v3/admin-desktop/map/pallets', { headers }).toPromise();
  }

  async getFilteredMapCrates(filter: string): Promise<ICrateMap[]> {
    const headers = {
      'Content-Type': 'application/json'
    };
    const queryParams = { search: filter };
    const params = appendParams(queryParams);
    return this.httpClient.get<ICrateMap[]>(environment.v3BaseUrl + '/api/v3/admin-desktop/map/pallets', { headers, params }).toPromise();
  }

  async getLevels(): Promise<any> {
    const headers = {
      'Content-Type': 'application/json'
    };
    return this.httpClient.get(environment.baseUrl + '/api/v1/admin-desktop/ground/levels', { headers }).toPromise<any>();
  }

  async getPositionCount(x?: number, y?: number): Promise<any> {
    const queryParams = {
      x: x,
      y: y
    };
    const params = appendParams(queryParams);
    return this.httpClient.get(environment.baseUrl + `/api/v1/admin-desktop/map/positions-count`, { params }).pipe(
      map(list => {
        const infoList = [];
        Object.keys(list).forEach(key => {
          infoList.push({
            name: this.translatePositionInfo(key),
            id: key,
            value: list[key]
          });
        });
        return infoList;
      })
    ).toPromise<any>();
  }

  translatePositionInfo(text: string) {
    switch (text) {
      case 'totalLevels':
        return 'Total de posições';
      case 'totalOccupiedLevels':
        return 'Total de posições ocupadas';
      case 'totalFreeLevels':
        return 'Total de posições livres';
    }
  }
}
